import posthog from 'posthog-js';

export function identify(userId: string, email: string, provider: string) {
  posthog.identify(userId, { email, provider });
}

export function reset() {
  posthog.reset();
}

export function capture(event: string, properties?: Record<string, unknown>) {
  posthog.capture(event, properties);
}
